export default __webpack_public_path__ + "static/media/GrpIconNew.33ff35a8.png";